
import { Component, Prop, Vue } from 'vue-property-decorator';
import vModal from './vModal.vue';
import { mapState } from "vuex";
import { LocalizationState } from "@/store/modules/LocalizationModule";
import { desanitizeString, tableMapper } from '@/utils/Helpers';
import { Recipe } from '@/models/Recipes/Recipe';
import vTable from "@/components/vTable.vue";
import vAminoAcidScoreReport from "@/components/reports/vAminoAcidScoreReport.vue";
import vDropdownButton from "@/components/bootstrap/vDropdownButton.vue";

@Component({
  components: {
    vModal,
    vTable,
    vAminoAcidScoreReport,
    vDropdownButton
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
    })
  }
})
export default class vRecipeDetails extends Vue {
  localizationState: LocalizationState;
  desanitizeString = desanitizeString;

  @Prop() recipe: Recipe;
  @Prop() isRecipe : boolean;

  get translations() {
    return this.localizationState.translations;
  }

  editRecipeOrDish() {
    if(this.isRecipe){
      return this.$router.push({ name: 'recipesEdit', params: { id: `${this.recipe.id}` } });
    }
    else{
      return this.$router.push({
        name: "dishesEdit",
        params: { id:  `${this.recipe.id}` },
      });
    }
  }

  /**
   * vTable friendly data
   */
  get tableHeaders() {
    let recipeWeightTableHeader = null;
    if (
      this.recipe.nutritionAnalysis.servingUnitOfMeasurement == "ml"
      || this.recipe.nutritionAnalysis.servingUnitOfMeasurement == "fl. oz"
    ) {
      recipeWeightTableHeader = "Total Volume (mL)";
    }
    else {
      recipeWeightTableHeader = "Total Weight (g)";
    }

    return [
      {
        name: this.translations.get("ingr_table_ene"),
        key: "Energy",
        searchable: false,
        searchString: "",
        sortable: false,
      },
      {
        name: this.translations.get("ingr_calories_from_fat") + " (g)",
        key: "CaloriesFromFat",
        searchable: false,
        searchString: "",
        sortable: false,
      },
      {
        name: this.translations.get("ingr_table_fat") + " (g)",
        key: "Fat",
        searchable: false,
        searchString: "",
        sortable: false,
      },
      {
        name: this.translations.get("ingr_table_sat") + " (g)",
        key: "SaturatedFattyAcids",
        searchable: false,
        searchString: "",
        sortable: false,
      },
      {
        name: this.translations.get("ingr_table_trans") + " (g)",
        key: "TransFattyAcids",
        searchable: false,
        searchString: "",
        sortable: false,
      },
      {
        name: this.translations.get("ingr_table_chol") + " (mg)",
        key: "Cholesterol",
        searchable: false,
        searchString: "",
        sortable: false,
      },
      {
        name: this.translations.get("ingr_table_sod") + " (mg)",
        key: "Sodium",
        searchable: false,
        searchString: "",
        sortable: false,
      },
      {
        name: this.translations.get("ingr_table_carb") + " (g)",
        key: "Carbohydrate",
        searchable: false,
        searchString: "",
        sortable: false,
      },
      {
        name: this.translations.get("ingr_table_fib") + " (g)",
        key: "Fibre",
        searchable: false,
        searchString: "",
        sortable: false,
      },
      {
        name: this.translations.get("ingr_table_sug") + " (g)",
        key: "Sugars",
        searchable: false,
        searchString: "",
        sortable: false,
      },
      {
        name: this.translations.get("ingr_table_prot") + " (g)",
        key: "Protein",
        searchable: false,
        searchString: "",
        sortable: false,
      },
      {
        name: this.translations.get("ingr_table_vitD") + " (mcg)",
        key: "VitaminD",
        searchable: false,
        searchString: "",
        sortable: false,
      },
      {
        name: this.translations.get("ingr_table_vitc") + " (mg)",
        key: "VitaminC",
        searchable: false,
        searchString: "",
        sortable: false,
      },
      {
        name: this.translations.get("ingr_table_pot") + " (mg)",
        key: "Potassium",
        searchable: false,
        searchString: "",
        sortable: false,
      },
      {
        name: this.translations.get("ingr_table_calc") + " (mg)",
        key: "Calcium",
        searchable: false,
        searchString: "",
        sortable: false,
      },
      {
        name: this.translations.get("ingr_table_iron") + " (mg)",
        key: "Iron",
        searchable: false,
        searchString: "",
        sortable: false,
      },
      {
        name: recipeWeightTableHeader,
        key: "Weight",
        searchable: false,
        searchString: "",
        sortable: false,
      },
    ];
  }

  /**
   * Transforms selected recipe to vTable component friendly data for the recipe details table
   */
  get transformRecipe() {
    return [tableMapper(this.recipe)];
  }
}
